import { useIntl } from 'react-intl';
import { IconCustomBoltPause } from '@rossum/ui/icons/tabler';
import { ActivityRowLayout, RowIcon, RowLabel, RowValue } from '../../core';

type AutomationBlockerRowProps = {
  blockerType: string;
  fields: string[];
};

export const AutomationBlockerRow = ({
  blockerType,
  fields,
}: AutomationBlockerRowProps) => {
  const intl = useIntl();
  return (
    <ActivityRowLayout
      dataCy="document-history-blocker-row"
      label={
        <RowLabel
          label={intl.formatMessage({
            id: 'features.documentHistory.field.automationBlocker',
          })}
        />
      }
      labelIcon={<RowIcon icon={IconCustomBoltPause} />}
      value={
        <RowValue value={fields.length ? fields.join(', ') : blockerType} />
      }
    />
  );
};
